<template>
<div id="app1">
    <router-view></router-view>
  
</div>
</template>


<script>
import { useRouter } from 'vue-router'
 
export default {
 
}

</script>
<style>
 *{
  margin:0;
  padding:0;
  list-style: none;
  text-decoration: none;
  outline: none;
}

</style>
